import { Icon } from "../../../../Atoms/Icons/Icon/Icon";

import styles from "./ErrorMessage.module.scss";

import WarningIcon from "../../../../Atoms/Icons/Types/WarningCircle/warning-circle-fill.svg";

interface IErrorMessageProps {
    /**
    * The optional text input ID.
    */
    id?: string;

    /**
    * The text message of the error.
    */
    errorText: string;
}

/**
 * The error message.
 * @param {IErrorMessageProps} param The props used to render the error message.
 * @returns The rendered component.
 */
function ErrorMessage({
    id,
    errorText
}: Readonly<IErrorMessageProps>): JSX.Element {
    return (
        <div
            className={styles.errorMessage}
            id={id}
            aria-live="polite"
        >
            <Icon
                size="sm"
                colorVariant="error"
            >
                <WarningIcon role="alert" />
            </Icon>
            {errorText}
        </div>
    );
}

export { ErrorMessage };
